import { useCreateReplyMutation } from "@/services";
import { Form, Input, Modal } from "antd";
import { bool, func, string } from "prop-types";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { CommentItem } from "./styled";

const { TextArea } = Input;

export const ReplyToCommentModal = ({
  isVisible,
  setVisible,
  target,
  targetId,
  projectId,
  commentId,
}) => {
  const [form] = Form.useForm();
  const intl = useIntl();

  const routeParams = {
    projectId,
    target,
    targetId,
    commentId,
  };

  const [createReply, { isLoading }] = useCreateReplyMutation();

  const handleOk = () => {
    form.validateFields().then((values) => {
      const commentData = {
        text: values.text,
      };

      createReply({ routeParams, body: commentData })
        .unwrap()
        .then(() => {
          toast.success(intl.formatMessage({ id: "comments.commentSuccess" }));
          form.resetFields();
          setVisible(false);
        })
        .catch(() => {
          toast.error(intl.formatMessage({ id: "general.error" }));
        });
    });
  };

  return (
    <Modal
      title={intl.formatMessage({ id: "comments.replyToComment" })}
      open={isVisible}
      centered={true}
      onOk={() => handleOk()}
      okText={intl.formatMessage({ id: "comments.post" })}
      okButtonProps={{
        loading: isLoading,
      }}
      onCancel={() => setVisible(false)}
      cancelText={intl.formatMessage({ id: "general.cancel" })}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        name="comment-form"
        disabled={isLoading}
      >
        <CommentItem
          name="text"
          label={intl.formatMessage({ id: "comments.comment" })}
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "comments.noValue" }),
            },
          ]}
        >
          <TextArea rows={4} />
        </CommentItem>
      </Form>
    </Modal>
  );
};

ReplyToCommentModal.propTypes = {
  isVisible: bool.isRequired,
  setVisible: func.isRequired,
  target: string.isRequired,
  targetId: string.isRequired,
  projectId: string.isRequired,
  commentId: string.isRequired,
  onSuccessfulReply: func,
};
